<template>
  <div class="banner-box">
    <img :src="bannerObj.img" alt="">
    <div class="content-box">
      <p class="title">{{bannerObj.title}}</p>
      <p class="content" :style="bannerObj.contentStyle" v-html="bannerObj.content"></p>
    </div>
    <button class="btn" @click="toParent">{{bannerObj.button}}</button>
  </div>
</template>

<script>
export default {
  props: {
    bannerObj: {
      type: Object
    }
  },
  methods: {
    toParent () {
      this.$emit('dialogVisible', true)
    }
  }
}
</script>

<style scoped>
  .banner-box{
    position: relative;
    width: 100%;
    height: 400px;
  }
  .banner-box>img{
    width: 100%;
    height: 100%;
  }
  .content-box{
    position: absolute;
    top: 30%;
    left: 18%;
    color: #ffffff;
    max-width: 650px;
    text-align: left;
  }
  .content-box .title{
    font-size:50px;
    font-family:PingFang SC;
    font-weight:600;
    line-height:70px;
    color:rgba(255,255,255,1);
    margin-bottom: 10px;
  }
  .content-box .content{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:400;
    line-height:32px;
    color:rgba(255,255,255,1);
    margin-bottom: 30px;
  }
  .btn{
    position: absolute;
    bottom: 15%;
    left: 18%;
    width:132px;
    height:40px;
    background:rgba(252,189,1,1);
    border: none;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    outline: none;
    cursor: pointer;
    border-radius:2px;
  }
  .btn:active{
    background:rgba(252,160,1,1);
  }
</style>



// WEBPACK FOOTER //
// src/components/banner.vue